module.exports = __webpack_public_path__ + "img/IMG_8949.93f35664.jpg";